module.exports = __webpack_public_path__ + "static/img/service_head_01_zh_h5.0a76d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_head_01_zh_h5.png
// module id = zmG/
// module chunks = 34